import { render, staticRenderFns } from "./RgpList.vue?vue&type=template&id=2f255fc2&scoped=true&"
import script from "./RgpList.vue?vue&type=script&lang=js&"
export * from "./RgpList.vue?vue&type=script&lang=js&"
import style0 from "./RgpList.vue?vue&type=style&index=0&id=2f255fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f255fc2",
  null
  
)

export default component.exports